// Kopie aus aivy-customer-dashboard, nicht von Hand ändern.
// Quelle ist src/helpers/sample-data.js (Zeilen 42 bis 118), der Stand steht in
// UPSTREAM.json daneben. Angepasst sind nur die Importpfade. Eine neue
// Regel kommt zuerst ins Dashboard, danach wird diese Datei neu kopiert und
// die Checksumme in UPSTREAM.json nachgezogen. upstream.test.js prüft das.

// customer_dashboard_meta einer Stelle ist ein JSON-String (Discover schreibt
// JSON.stringify) oder schon ein Objekt. Kaputtes JSON zählt als leer.
export const parseCareerMeta = (meta) => {
  let value = meta

  try {
    for (let i = 0; i < 2 && typeof value === 'string'; i++) {
      value = JSON.parse(value)
    }
  } catch {
    return {}
  }

  if (!value || typeof value !== 'object' || Array.isArray(value)) return {}

  return value
}

const SAMPLE_CAREER_ID_PREFIX = 'career_example_'

export const sampleCareerIdWithMust = (partnerId) =>
  `${SAMPLE_CAREER_ID_PREFIX}with_must_${partnerId}`

export const sampleCareerIdWithoutMust = (partnerId) =>
  `${SAMPLE_CAREER_ID_PREFIX}without_must_${partnerId}`

const SAMPLE_SPACE_FITS = ['good_fit', 'low_fit_on_must', 'mid_fit', 'low_fit']

const legacySampleCareerIds = (partnerId) => [
  sampleCareerIdWithMust(partnerId),
  sampleCareerIdWithoutMust(partnerId)
]

const legacySampleSpaceIds = (partnerId) =>
  legacySampleCareerIds(partnerId).flatMap((careerId) =>
    SAMPLE_SPACE_FITS.map((fit) => `sample_talent_example_${fit}_${careerId}`)
  )

const hasOwnFixedId = (record, buildIds) =>
  typeof record.partner_id === 'string' &&
  !!record.partner_id &&
  buildIds(record.partner_id).includes(record.id)

// Altbestand ohne Flag: generateDemoData setzt is_demo an Stellen erst seit
// 18.12.2025, an Talenten erst seit 11.02.2026, ein Backfill gibt es nicht.
// Solche Beispieldaten erkennt nur die feste ID, und nur solange das Flag
// fehlt (GraphQL liefert dann null). Die ID muss zur eigenen partner_id
// passen. Eine zur normalen Stelle gewordene Beispielstelle trägt is_demo
// false und fällt so heraus. Im Backend identisch.
const isLegacySampleCareer = (career) =>
  career.is_demo == null && hasOwnFixedId(career, legacySampleCareerIds)

const isLegacySampleSpace = (space) =>
  space.is_demo == null &&
  space.is_demo_data == null &&
  hasOwnFixedId(space, legacySampleSpaceIds)

// Discover-Vorlagenstellen tragen das Flag nur in der Meta.
export const isSampleCareer = (career) =>
  !!career &&
  (career.is_demo === true ||
    parseCareerMeta(career.customer_dashboard_meta).is_demo === true ||
    isLegacySampleCareer(career))

export const isSampleSpace = (space) =>
  !!space &&
  (space.is_demo === true ||
    space.is_demo_data === true ||
    isLegacySampleSpace(space))

// Von generateDemoData angelegt (Flag oder Altbestand, feste ID). Für die
// Einladen-Filter: Discover-Stellen bleiben einladbar, und eine zur normalen
// Stelle gewordene Beispielstelle (is_demo false, ID bleibt) ebenso.
export const isGeneratedSampleCareer = (career) =>
  isSampleCareer(career) &&
  typeof career.id === 'string' &&
  career.id.startsWith(SAMPLE_CAREER_ID_PREFIX)
